import React,{useState,useEffect,useRef} from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import DriverCars from "./DriverCars";
import {MAIN_COLOR,SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions";
import { makeStyles} from '@mui/styles';
import { BankDetails } from "./BannkDetails";
import UserRides from "./UserRides";
import UserWalletDetails from "./UserWalletDetails";
import UserInfoDetails from "./UserInfoDetails";
import { Typography, Chip, Button as MuiButton, Paper } from "@mui/material";
import { api } from 'common';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
const useStyles = makeStyles({

  tabs: {

    "& .MuiTabs-indicator": {
      backgroundColor: SECONDORY_COLOR,
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: MAIN_COLOR
    }
  },
  typography:{
    fontFamily:FONT_FAMILY
  }
})

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DRIVER_BADGES = [
  { key: 'founding',   label: 'Founding Driver',   icon: '🏁' },
  { key: 'premium',    label: 'Premium Driver',     icon: '⭐' },
  { key: 'fuel',       label: 'Fuel Saver',         icon: '🍃' },
  { key: 'weekly',     label: 'Weekly Winner',      icon: '🏆' },
  { key: 'ambassador', label: 'SAWI Ambassador',    icon: '🎖️' },
];

function BadgesPanel({ data }) {
  const dispatch = useDispatch();
  const { editUser } = api;
  const settings = useSelector(s => s.settingsdata.settings);
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    setBadges(data?.badges || []);
  }, [data]);

  const toggleBadge = (key) => {
    if (!settings?.AllowCriticalEditsAdmin) { alert('Demo mode'); return; }
    const next = badges.includes(key) ? badges.filter(b => b !== key) : [...badges, key];
    setBadges(next);
    dispatch(editUser(data.id, { ...data, badges: next }));
  };

  return (
    <Paper style={{ padding: '20px', borderRadius: '8px' }}>
      <Typography style={{ fontFamily: FONT_FAMILY, fontWeight: 'bold', marginBottom: '12px' }}>
        <EmojiEventsIcon style={{ verticalAlign: 'middle', marginRight: 6, color: '#f0a500' }} />
        Driver Badges
      </Typography>
      <Typography style={{ fontFamily: FONT_FAMILY, fontSize: '13px', color: '#666', marginBottom: '16px' }}>
        Click a badge to toggle it on/off for this driver.
      </Typography>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {DRIVER_BADGES.map(b => (
          <Chip
            key={b.key}
            label={`${b.icon} ${b.label}`}
            onClick={() => toggleBadge(b.key)}
            style={{
              fontFamily: FONT_FAMILY,
              backgroundColor: badges.includes(b.key) ? '#f0a500' : '#eee',
              color: badges.includes(b.key) ? '#fff' : '#333',
              cursor: 'pointer',
            }}
          />
        ))}
      </div>
      {badges.length > 0 && (
        <Typography style={{ fontFamily: FONT_FAMILY, fontSize: '12px', color: '#888', marginTop: '12px' }}>
          Active: {badges.map(k => DRIVER_BADGES.find(b => b.key === k)?.label).filter(Boolean).join(', ')}
        </Typography>
      )}
    </Paper>
  );
}

export default function DriverDetails() {
  const { id } = useParams();
  const [value, setValue] = React.useState(0);
  const { t, } = useTranslation();
  const [data,setData] = useState([])
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const navigate = useNavigate();
  const loaded = useRef(false);
  const classes = useStyles();

  useEffect(() => {
    if (staticusers) {
      const user = staticusers.filter((user) => (user.id === id.toString()) && (user.usertype === "driver") )[0];
      if (!user) {
        navigate("/404");
        return;
      }
      setData(user);
    } else {
        setData([]);
      }
    loaded.current = true;
  }, [staticusers,id,navigate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs  value={value} onChange={handleChange} aria-label="Driver tabs" className={classes.tabs} variant="scrollable" >
          <Tab
            label={ <Typography className={classes.typography}>{t('info')}</Typography>}
            {...a11yProps(0)}
          />
          <Tab
            label={ <Typography className={classes.typography}>{t('rides')}</Typography>}
            {...a11yProps(1)}
          />
          <Tab
            label={ <Typography className={classes.typography}>{t('cars')}</Typography>}
            {...a11yProps(2)}
          />
          <Tab
            label={ <Typography className={classes.typography}>{t('wallet')}</Typography>}
            {...a11yProps(3)}
          />
          <Tab
            label={ <Typography className={classes.typography}>{t('bankDetails')}</Typography>}
            {...a11yProps(4)}
          />
          <Tab
            label={ <Typography className={classes.typography}>Badges</Typography>}
            {...a11yProps(5)}
          />
        </Tabs>
      </Box>
    
      <TabPanel value={value} index={0}>
        <UserInfoDetails data={data} />
      </TabPanel>
       <TabPanel value={value} index={1}>
          <UserRides 
          data= {data}
          tabid={1}
          />
        </TabPanel>
      <TabPanel value={value} index={2}>
        <DriverCars data= {data}/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <UserWalletDetails data={data}  id={1}  />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <BankDetails data= {data}/>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <BadgesPanel data={data} />
      </TabPanel>

    </Box>
  );
}